<template>
	<div class="d-flex flex-column ">
				<header class="mdc-top-app-bar darkModeHeader" id="darkModeHeader">
					<div class="d-flex align-items-center pdl-30 pdr-30 justify-conetent-between h-full">
						<div
							class="t-subtitle3 t-color-whiteHigh  d-flex align-items-center pdr-24 font-r t-line-1 mgr-30">
							{{ lessonName }}
						</div>
						<div class="d-flex align-items-center justify-content-end flex-grow-1">
							<div class="position-relative w-80 mgr-24">
								<div class="percentage-wrapper">
									<div class="h-2 position-relative total-percentage  bg-whiteBorder h-4">
										<div class="real-percentage bg-saleLine b-radius0 h-4 mgt-2"
											:style="{width: rate+'%'}">
										</div>
									</div>
								</div>
							</div>
							<div class="d-flex align-items-baseline mgr-24 t-nowrap">
								<div
									class="t-headline10 t-color-whiteHigh t-line-h-15 d-flex align-items-center  font-b">
									{{rate}}
								</div>
								<div class="t-body3 font-m mgl-4 t-color-whiteHigh">%</div>
							</div>
							<button
								 @click="moveLearnViewClose()" @keypress="moveLearnViewClose()" tabindex="0"
								class="mdc-button mdc-button--outlined mdc-button--raised t-color-secondaryBtnText videoHeaderBtn b-radius4  pdl-12 pdr-12">
								<span class="mdc-button__ripple"></span>
								<span class="mdc-button__label t-body2 font-r t-color-whiteHigh t-nowrap">{{ $t('3182') }}</span>
							</button>
						</div>
					</div>
					<div class="divider" v-if="lightModeActive"></div>
				</header>

				<div class="d-flex pdf-container"
					style="height: calc(100vh - 132px); padding-top:64px; "
					:class="{
						 'width-learning-object':isLearningObjective,
			'width-learning-material':isResources,
			'width-slide-chat':isQuestionAns
					}" >

					<div class="flex-grow-1 position-relative" id="waterMarkInner">
						<!-- <canvas id="the-canvas"></canvas> -->
						<iframe data-v-0ef8941c="" :src="`/pdfjs/web/viewer.html?file=${pdfFileUrl}#zoom=90`" width="100%"
							height="100%" frameborder="0" scrolling="0" id="pdfIfrem">
						</iframe>
						<!-- <div class="waterMarkContainer position-absolute d-flex align-items-center justify-content-center flex-column"> -->
							<span class="waterMarkInner">
								<span class="t-headline7 t-color-whiteSelected t-center mgb-16">{{ personalInfo?personalInfo.userId:'' }}</span>
								<span class="t-headline7 t-color-blackHover t-center">{{ personalInfo?personalInfo.userId:'' }}</span>
							</span>
						<!-- </div> -->

					</div>
					<div class="description-sidebar t-color-white " v-if="isLearningObjective" :class="lightModeActive ? 'bg-documentGray' : ''">
						<div class="pdt-27 pdb-26 pdl-24 pdr-24 sidebarHeader-slide position-relative" :class="lightModeActive ? 'bg-documentGray' : ''">
							<div class="position-abosolute d-flex justify-content-between align-items-center ">
								<div class="t-subtitle3 font-m paging" :class="lightModeActive ? 't-color-headlineHigh' : 't-color-white'">{{  $t('1046') }}</div>
								<div class="d-flex align-items-center">
									<a tabindex="0" @click="setisLearningObjective" @keypress="setisLearningObjective" href="javascript:void(0)" class="closebtn pdt-4" :class="lightModeActive ? 't-color-headlineHigh' : 't-color-white'">
										<i	class="material-icons w-22 ">close</i>
									</a>
								</div>
							</div>
						</div>
						<div class="pdl-24 pdr-24 t-color-whiteHigh2 font-r t-body1 t-line-h-28 pdt-20">
							<span class="pdb-32">{{ learnPurposes }}</span>
						</div>
					</div>
					<div class="learning-material-sidebar t-color-white" v-if="isResources"  :class="lightModeActive ? 'bg-documentGray' : 'bg-contentPlayerBg'">
						<div class="pdt-27 pdb-27 pdr-24 pdl-24 sidebarHeader-slide position-relative" :class="lightModeActive ? 'bg-documentGray' : 'bg-contentPlayerBg'">
							<div class="position-abosolute d-flex justify-content-between align-items-center ">
								<div class="t-subtitle3 font-m paging" :class="lightModeActive ? 't-color-headlineHigh' : 't-color-white'">{{$t('1046')}}</div>
								<div class="d-flex align-items-center">
									<a href="javascript:void(0)"	class="closebtn pdt-4" :class="lightModeActive ? 't-color-headlineHigh' : 't-color-white'" @click="setisResources" @keypress="setisResources" tabindex="0">
										<i class="material-icons w-22 ">close</i>
									</a>
								</div>
							</div>
						</div>
						<div class="mgt-8 pdl-24 pdr-24"  v-if="lessonData && lessonData.learningMaterials && lessonData.learningMaterials.length > 0" >
								<div
									class="d-flex align-items-center justify-content-between pdt-4 pdb-4 bg-whiteHover b-whiteBorder b-radius4 mgb-16">
									<div class="d-flex align-items-center flex-grow-1 mgl-24">
										<button
											class="material-icons mdc-icon-button t-color-secondaryBtnText mgl--12">attach_file</button>
										<span class="t-color-whiteHigh t-body1 font-rn pdl-20">{{ lesson.learningMaterials[0].file.originalName }}</span>
									</div>
									<div>
										<button
											class="material-icons mdc-icon-button t-color-iconInactiveText mgr-12" tabindex="0" @click="donwloadFile(lesson.learningMaterials[0])" @keypress="donwloadFile(lesson.learningMaterials[0])">download</button>
									</div>
								</div>
						</div>
					</div>
					<question-ans
						v-if="isQuestionAns"
						:learnId="this.$route.params.learnId"
						:lessonId="this.$route.params.lessonId"
						:isQuestionAns="isQuestionAns"
						:chatType ="'learn'"
						:islightModeActive = "lightModeActive"
						@setisQuestionAnsHandler="setisQuestionAns"
					>
					</question-ans>

				</div>

				 <div class="slider-footer">

					<div class="range-slider range-slider__range"  >
						<!-- <input class="range-slider__range  " type="range" :value="( pdfPagenumber / pdfTotalpage ) * 100 " min="0" max="100"> -->
						<div class="home-progressbar video-status position-absolute" :style="`width:${progressBar}%;`"></div>
					</div>
					<div class="divider" v-if="lightModeActive"></div>
					<div class="d-flex justify-content-between  footer-learning " :class="lightModeActive ? '':'bg-contentPlayerBg'" >
						<div class="pdl-50 pdt-4 d-flex align-items-center">
							<span tabindex="0" @click="darkModeToLight()" @keypress="darkModeToLight()">
							<img  :src="lightModeActive?'/img/lightModeFixedButton.png':'/img/darkModeFixedButton.svg'" alt="mode control" class="cursor-pointer w-32 h-32">
							</span>
							<span class="d-inline-block bg-whiteBorder w-1 h-28 mgl-24 mgr-24"></span>

							<span tabindex="0"  @click="zoomOut" @keypress="zoomOut" :class="zoomPercentCustom<=10?'disAbledPlusAndMinus':''"  class="cursor-pointer"><img :src="lightModeActive ? '/img/zoon-minus-light.png': '/img/zoon-minus.png'" alt="zoom view minus" class="w-32 h-32" ></span>

							<span class="pdl-24 t-color-whiteHigh t-subtitle5 pdr-24 t-nowrap"> {{zoomPercentCustom}}% </span>
							<span tabindex="0" @click="zoomIn" @keypress="zoomIn" :class="zoomPercentCustom>=300?'disAbledPlusAndMinus':''"  class="cursor-pointer"><img :src="lightModeActive ? '/img/zoom-plus-light.png':'/img/zoom-plus.png'" alt="zoom view plus" class="w-32 h-32"  ></span>
							<span class="d-inline-block bg-whiteBorder w-1 h-28 mgl-24 mgr-24 t-nowrap"></span>
							<span tabindex="0" @click="presentationMode()" @keypress="presentationMode()"  class="cursor-pointer"><img :src="lightModeActive ? '/img/fit-to-page-light.png' : '/img/fit-to-page.png'" alt="fit to page" class="w-32 h-32 mgr-24"></span>
							<span  class="cursor-pointer"><img :src="lightModeActive ? '/img/fit-to-scroll-active-light.svg':'/img/fit-to-scroll-active.svg'" alt="full scren view" class="w-32 h-32"></span>
							<span class="d-inline-block bg-whiteBorder w-1 h-28 mgl-24 mgr-24"></span>
							<span tabindex="0"  @click="scrollHorizontal" @keypress="scrollHorizontal"  class="cursor-pointer" >
								<img :src="lightModeActive ? '/img/arrow-h-light.png': '/img/arrow-h.png'" alt="align horizontal" v-if="isVertical" class="w-32 h-32 mgr-24">
								<img :src="lightModeActive ? '/img/arrow-h-active-light.png' : '/img/arrow-h-active.png'" alt="align horizontal" v-else class="w-32 h-32 mgr-24">
							</span>
							<span @click="scrollVertical" @keypress="scrollVertical"  tabindex="0" class="cursor-pointer">
								<img :src="lightModeActive ? '/img/arrow-v-active-light.png':'/img/arrow-v-active.png'" alt="align vertical" v-if="isVertical" class="w-32 h-32 ">
								<img :src="lightModeActive ? '/img/arrow-v.png' : '/img/arrow-v.png'" alt="align vertical" v-else class="w-32 h-32">
							</span>
							<span class="d-inline-block bg-whiteBorder w-1 h-28 mgl-24 mgr-24"></span>

						</div>
						<div class="d-flex align-items-center justify-content-center pdt-4 footer-center-absolute">
							<!-- <input type="number" name="" id="pdf-page" :value="pdfPagenumber"> -->
							<div class="t-color-whiteHigh t-subtitle5 mgl-8"> {{pdfPagenumber}} </div>
							<div class="t-color-whiteMedium t-body7 mgl-8 t-nowrap" > / {{pdfTotalpage}} </div>
						</div>
						<div class="d-flex align-items-center pdt-4 justify-content-end mgr-50">
							<div class="d-flex align-items-center">
								<button
									@click="onLike" @keypress="onLike" tabindex="0"
									:class="likes ? 't-color-red' : 't-color-whiteDisabled'"
									class="material-icons mdc-icon-button  mgl--12 l-icon">favorite</button>
								<span class="t-body6 t-color-whiteHigh font-rn pdl-8">{{ likesCount }}</span>
							</div>
							<div class="d-flex align-items-center mgl-24 mgr-24">
								<button
									@click="onBookmark" @keypress="onBookmark"
									:class="clipping ? 't-color-contentBlue' : 't-color-whiteDisabled'"
									class="material-icons mdc-icon-button  mgl--12 l-icon">bookmark</button>
								<span class="t-body6 t-color-whiteHigh font-rn pdl-8">{{ clippingCount }}</span>
							</div>
							<span  class="cursor-pointer"><img :src="lightModeActive ? '/img/information-light.png':'/img/information.png'" alt="information" class="l-icon" @click="setisLearningObjective" @keypress="setisLearningObjective" tabindex="0" ></span>
							<!-- <span><img src="/img/download.png" alt="download" class="l-icon" @click="setisResources" ></span> -->
							<span  class="cursor-pointer"><img :src="lightModeActive?'/img/list-icon-light.svg':'/img/list-icon.svg'" alt="index" class="l-icon mgl-24 mgr-24  rtl-support" @click="sidebarToggle()" @keypress="sidebarToggle()" tabindex="0" ></span>
							<button tabindex="0" @click="setisQuestionAns(),closeImageNav()" @keypress="setisQuestionAns(),closeImageNav()" class="mdc-button mdc-button--raised t-color-contentText min-w-auto" :class=" lightModeActive  ? 'bg-contentPlayerBgLight' : 'bg-secondaryBtn'">
								<div class="mdc-button__ripple"></div>
								<span class="mdc-button__label t-body2 font-r t-nowrap">{{$t('3184')}}</span>
							</button>
						</div>

					</div>
				</div>

			</div>

</template>
<script>
/**
 * 나의 학습 차시 학습창 - PDF 컨텐츠 컴포넌트(my learning lesson study - PDF content component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import learnApi from '@/api/learnApi.js'
import ImageSlider from './slider/ImageSlider.vue'
import {slideTypeMixins} from '../../mixins/slideType.js'
import LikeAndBookmark from "./LikeAndBookmark.vue";
import LessonsList from './LessonsList.vue'
import memberApi from '@/api/memberApi.js';
import {MDCRipple} from '@material/ripple'
import questionAns from '../questionContent/List.vue'
import localStorageUtil from "@/utils/localStorageUtil";

export default {
	data() {
		return {
			pdfFileUrl: '',
			slideFiles: [],
			lessonData: null,
			lessonName: '',
			lessonsList: [],
			nextLessonName: '',
			currentProgressionId: '',
			rate: 0,
			last: 0,
			recent: 0,
			time: 0,
			currentSlide: 0,
			showLectureList: false,

			// 북마크 좋아요 관려 데이터(like & bookmark data)
			isLiked: false,
			isBookmarked: false,
			likes: false,
			likesCount: 0,
			clipping: false,
			clippingCount: 0,

			isAllPages: false,
			isScroll: false,
			isTimeline: false,
			isExpand: false,

			personalInfo:null,
			pdfPagenumber:0,
			pdfTotalpage:0,
			pdfZoomPecent:'',
			pdfZoomPecent1:'',
			pdfInterval: null,
			zoomPercentCustom:90,
			pdfIfrem:null,
			isVertical:true,

			isQuestionAns:false,
			isLearningObjective:false,
			isResources:false,
			isNextLession:false,

			setQuestionAns:'',
			setLearningObjective:'',
			setResources:'',

			learnPurposes: '',
			sidebarToggleCount:1,

			progressBar:0,

			lightModeActive:false
		}
	},

	components: {
		'lessons-list' : LessonsList,
		'like-and-bookmark': LikeAndBookmark,
		'question-ans':questionAns
	},

	mixins: [slideTypeMixins],
	watch: {
		// set total number of page
		pdfPagenumber: function() {
			this.setRangeSlider();
			this.updateProgress();
			//this.scrollVertical();
			let addClassIndex = document.getElementById("pdfIfrem").contentWindow.document.getElementById("toolbarSidebar");
			let addClassIndexCard = document.getElementById("pdfIfrem").contentWindow.document.getElementById("thumbnailView");
			let addClassIndexTextCard = document.getElementById("pdfIfrem").contentWindow.document.getElementById("indexTextColor");
			let addClassIndexCloseCard = document.getElementById("pdfIfrem").contentWindow.document.getElementById("indexCloseColor");
			if(this.lightModeActive === true) {
				addClassIndex.className = 'cssClass';
				addClassIndexCard.className = 'cssClass';
				addClassIndexTextCard.className = 'cssClass';
				addClassIndexCloseCard.className = 'cssClass';
			} else {
				addClassIndex.classList.remove("cssClass")
				addClassIndexCard.classList.remove("cssClass")
				addClassIndexTextCard.classList.remove("cssClass")
				addClassIndexTextCard.classList="t-body6 font-r paging"
				addClassIndexCloseCard.classList.remove("cssClass")

			}

      this.$nextTick(() => {
        let viewerContainer = document.getElementById('pdfIfrem').contentWindow.document.getElementById('viewerContainer')
        viewerContainer.addEventListener('scroll', () => {
          if((viewerContainer.scrollTop + $(viewerContainer).height()) >= viewerContainer.scrollHeight) {
            this.pdfPagenumber = this.pdfTotalpage;
            this.updateProgress();
          }
        })
      })

			// vertical scroll
			if(this.isVertical === true) {
				setTimeout(()=>{
				document.getElementById("pdfIfrem").contentWindow.document.getElementById("scrollVertical").click()
				this.scrollVertical()
				}, 500);
			}
		}
	},

    beforeDestroy() {
        clearInterval(this.pdfInterval);

		// keydown 이벤트 리스너 제거
		document.removeEventListener('keydown', this.preventSaveAndPrint);
    },

	mounted() {
			const article = document.querySelector('html');
			const modeContent = article.getAttribute("data-theme");
			if(localStorage.getItem('themeMode')){
				article.setAttribute("data-theme", localStorage.getItem('themeMode'));
				this.lightModeActive = localStorage.getItem('themeMode') == 'dark' ? false : true;
			}
			else{
				if(modeContent == "dark")
					this.lightModeActive = false;
				else
					this.lightModeActive = true;
			}

		// set parameter
		let paramsObj = {
				learnId: this.$route.params.learnId,
				progressionId: this.$route.params.progressionId
			};
	
		learnApi.openNextLearning(this.$route.params.learnId)
        	.then(() => {
				learnApi.learnLessonObjective(paramsObj).then((response) => {
					let responseData = response.data.data
					this.teacherName = responseData.teacher?responseData.teacher.fullName:''
					this.learnPurposes = this.getLearnPurposes(responseData.learnInfo)
				})
			})
			.catch((err) => {
				console.log("ERROR OPEN NEXT LEARNING API : ", err);
			});
		

		this.pdfIfrem = document.getElementById("pdfIfrem");

		this.pdfInterval = setInterval(() => {
			this.setRangeSlider();
			this.pdfZoomPecent = document.getElementById("pdfIfrem").contentWindow.document.getElementById("customScaleOption")?document.getElementById("pdfIfrem").contentWindow.document.getElementById("customScaleOption").innerHTML:''
			this.pdfPagenumber = document.getElementById("pdfIfrem").contentWindow.document.getElementById("pageNumber").value;
			let x = document.getElementById("pdfIfrem").contentWindow.document.getElementById("numPages").innerHTML;
			this.pdfTotalpage = x.split(' ')[1];
		 }, 1000);

		this.setMaterialUi()
		this.setRangeSlider();
		let params = this.setParams()
		let responseData = null
		window.onpopstate = function(event) {
			this.moveLearnViewClose()
		};

		//차시 컨텐츠 정보 API 호출(get lesson contents data)
		learnApi.learnLessonContents(params).then((response) => {
			responseData = response.data.data

			this.lessonData = responseData
			this.lessonName = this.lessonData.lessonName
			this.rate = this.lessonData.rate
			this.pdfFileUrl = this.lessonData.pdf.file
			this.last = this.lessonData.last
			this.recent = this.lessonData.recent
			this.currentProgressionId = this.lessonData.progressionId

			this.likes = this.lessonData.likes
			this.likesCount = this.lessonData.likesCount
			this.clipping = this.lessonData.clipping
			this.clippingCount = this.lessonData.clippingCount
		 if (this.rate > 0 && this.rate < 100 ) {
				this.$confirm({
					title: this.$t('173'), // '학습 중인 강의입니다.',
					content: this.$t('174') + '<br>' + this.$t('175'), //'이전에 학습했던 이력이 있습니다.<br>이어서 학습하시겠습니까?',
					accept: this.$t('177'), //'이어서 보기',
					cancel: this.$t('176'), //'처음부터 보기',
				}).then(() => {
					document.getElementById("pdfIfrem").contentWindow.PDFViewerApplication.page=this.last;
					this.updateProgress()
				}).catch(() => {
				})
			}
		//	this.updateProgress();
			// 화면 로드 완료 후 진도저장(Save progress after loading the screen)

		}).catch((err) => {})

		// 차시목록 호출
		this.fetchLectureList()
		learnApi.getMemberInfo().then((response)=>{
			this.personalInfo = response.data.data
		})

		if(typeof(this.$route.query.questionChatType) !='undefined'){
			this.setisQuestionAns()
			//document.getElementById("video-container").classList.add('chat-active')
		}


		// 저장 및 인쇄 단축키 방지
		document.addEventListener('keydown', this.preventSaveAndPrint);
	},

	methods: {
		// set dark and light mode
		darkModeToLight(){
			const article = document.querySelector('html');
			const modeContent = article.getAttribute("data-theme");
			localStorage.setItem('themeMode', modeContent == "dark" ? "light" : "dark");
			article.setAttribute("data-theme", modeContent == "dark" ? "light" : "dark");
			this.lightModeActive = !this.lightModeActive;
			let addClassIndex = document.getElementById("pdfIfrem").contentWindow.document.getElementById("toolbarSidebar");
			let addClassIndexCard = document.getElementById("pdfIfrem").contentWindow.document.getElementById("thumbnailView");
			let addClassIndexTextCard = document.getElementById("pdfIfrem").contentWindow.document.getElementById("indexTextColor");
			let addClassIndexCloseCard = document.getElementById("pdfIfrem").contentWindow.document.getElementById("indexCloseColor");
			if(this.lightModeActive==true) {
				addClassIndex.className = 'cssClass';
				addClassIndexCard.className = 'cssClass';
				addClassIndexTextCard.className = 'cssClass';
				addClassIndexCloseCard.className = 'cssClass';
			} else {
				addClassIndex.classList.remove("cssClass")
				addClassIndexCard.classList.remove("cssClass")
				addClassIndexTextCard.classList.remove("cssClass")
				addClassIndexTextCard.classList="t-body6 font-r paging"
				addClassIndexCloseCard.classList.remove("cssClass")

			}
		},
	// zoom out pdf
	zoomOut(){
		this.pdfIfrem.contentWindow.document.getElementById("zoomOut").click();
		this.pdfZoomPecent1 = this.pdfIfrem.contentWindow.document.getElementById("customScaleOption").innerHTML
		let zoonPer = parseInt(this.zoomPercentCustom)-10
		if(zoonPer<10){
			this.zoomPercentCustom =10
		} else {
			this.zoomPercentCustom =zoonPer
		}

	},
	// zoom in pdf
	zoomIn(){
		this.pdfIfrem.contentWindow.document.getElementById("zoomIn").click();
		this.pdfZoomPecent1 = this.pdfIfrem.contentWindow.document.getElementById("customScaleOption").innerHTML
		let zoonPer = parseInt(this.zoomPercentCustom)+10
		if(zoonPer>=300){
			this.zoomPercentCustom =300
		} else {
			this.zoomPercentCustom =zoonPer
		}

	},
	// full screen pdf
	presentationMode(){
		this.isVertical = true;
		document.getElementById("waterMarkInner").requestFullscreen();
		this.pdfIfrem.contentWindow.document.getElementById("scrollVertical").click();
		this.pdfIfrem.contentWindow.document.getElementById("presentationMode").click();
	},
	// scroll pdf horizontal
	scrollHorizontal(){
		this.isVertical = false;
		//this.pdfIfrem.contentWindow.document.getElementById("spreadOdd").click();
		this.pdfIfrem.contentWindow.document.getElementById("scrollHorizontal").click();
		document.getElementById("pdfIfrem").contentWindow.PDFViewerApplication.page=this.last;
	},
	// scroll pdf vertical
	scrollVertical(){
		this.isVertical = true;
		this.pdfIfrem.contentWindow.document.getElementById("scrollVertical").click();
	},
	// set spread
	spreadNone(){
		this.pdfIfrem.contentWindow.document.getElementById("spreadNone").click();
	},

	spreadOdd(){
		this.pdfIfrem.contentWindow.document.getElementById("spreadOdd").click();
	},
	// pdf sidebar
	sidebarToggle(){

		if(this.isQuestionAns==true){
			this.isQuestionAns = false
		}
		if(this.isLearningObjective==true){
			this.isLearningObjective = false
		}
		if(this.isResources==true){
			this.isResources = false
		}

		this.pdfIfrem.contentWindow.document.getElementById("sidebarToggle").click();

		let addClassIndex = document.getElementById("pdfIfrem").contentWindow.document.getElementById("toolbarSidebar");
		let addClassIndexCard = document.getElementById("pdfIfrem").contentWindow.document.getElementById("thumbnailView");
		if(this.lightModeActive==true) {
			addClassIndex.className = 'cssClass';
			addClassIndexCard.className = 'cssClass';
		} else {
			addClassIndex.classList.remove("cssClass")
			addClassIndexCard.classList.remove("cssClass")
		}



	},
	setLikeAndBookParams() {
	  let params = {
		learnId: this.$route.params.learnId,
		progressionId: this.$route.params.progressionId,
	  };
	  return params;
	},
	// set toggle question and answer
	setisQuestionAns(){
		this.setQuestionAns = 'questionans';
		this.isQuestionAns = !this.isQuestionAns;
		if(this.isLearningObjective==true){
			this.isLearningObjective = false;
		}
		if(this.isResources==true){
			this.isResources = false;
		}
		let findClass = document.getElementById("pdfIfrem").contentWindow.document.getElementById("outerContainer");
		let findClassName = findClass.className;
		if(findClassName.includes('sidebarOpen')){
		   this.pdfIfrem.contentWindow.document.getElementById("sidebarToggle").click();
		}

	},
	// set toggle learning
	setisLearningObjective(){
		this.setLearningObjective = 'learningobjective';
		if(this.isResources==true){
			this.isResources = false;
		}
		if(this.isQuestionAns==true){
			this.isQuestionAns = false;
		}

		this.isLearningObjective = !this.isLearningObjective;
		let findClass = document.getElementById("pdfIfrem").contentWindow.document.getElementById("outerContainer");
		let findClassName = findClass.className;
		if(findClassName.includes('sidebarOpen')){
		   this.pdfIfrem.contentWindow.document.getElementById("sidebarToggle").click();
		}
	},
	// set toggle resource
	setisResources(){
		this.setResources = 'resources';
		if(this.isLearningObjective==true){
			this.isLearningObjective = false;
		}
		if(this.isQuestionAns==true){
			this.isQuestionAns = false;
		}
		this.isResources = !this.isResources;
	},
	// set like/Dislike pdf
	onLike() {
	  let params = this.setLikeAndBookParams();
	  let responseData = null;
	  if (this.likes) {
		learnApi
		  .learnLessonLikesDelete(params)
		  .then((response) => {
			responseData = response.data.data;
			//this.heartcolor={'color':'#758191 !important'}
			this.likes = response.data.data;
			this.likesCount = this.likesCount - 1;
		  })
		  .catch((err) => {});
	  } else {
		learnApi
		  .learnLessonLikesPost(params)
		  .then((response) => {
			//this.heartcolor={'color':'var(--secondaryBtnText) !important'}
			responseData = response.data.data;
			this.likes = response.data.data;
			this.likesCount = this.likesCount + 1;
		  })
		  .catch((err) => {});
	  }
	},

	// 북마크 API 호출(set/cancel bookmark)
	onBookmark() {
	  let params = this.setParams();
	  let responseData = null;
	  if (this.clipping) {
		learnApi
		  .learnLessonClippingDelete(params)
		  .then((response) => {
			responseData = response.data.data;
			this.clipping = responseData;
			this.clippingCount = this.clippingCount - 1

			this.toggleBookmarkIcon();
		  })
		  .catch((err) => {});
	  } else {
		learnApi
		  .learnLessonClippingPost(params)
		  .then((response) => {
			responseData = response.data.data;
			this.clipping = responseData;
			this.clippingCount = this.clippingCount + 1

		  })
		  .catch((err) => {});
	  }
	},
		// 진도저장 API 호출(update progress)
		updateProgress() {
			let progressBarLength = 0;
			let params = this.setParams();
			let responseData = null;

			progressBarLength = Math.floor(params.current*100/params.total)
			if(parseInt(progressBarLength)) {
				this.progressBar = progressBarLength;
			} else {
				this.progressBar = 0
			}

			learnApi.learnLessonProgression(params).then((response) => {
				responseData = response.data.data
				this.rate = responseData.rate
				this.last = responseData.last
			}).catch((err) => {})
		},

		// API 파라미터 설정(set parameter)
		setParams() {
			let params = {
				total: this.pdfTotalpage,
				current: this.pdfPagenumber,
				learnId: this.$route.params.learnId,
				progressionId: this.$route.params.progressionId
			}
			return params
		},

		// update likes count
		updateLikesCount(data) {
			this.likes = data.likes
			this.likesCount = data.likesCount
		},

		// update bookmark count
		updateBookmarkCount(data) {
			this.clipping = data.clipping
			this.clippingCount = data.clippingCount
		},

		// 학습 목록 API 호출(get lesson list)
		fetchLectureList() {
			// console.log('fetchLectureList');
			let responseData = null
			let params = this.setParams()

			//차시 정보
			learnApi.learnViewCourses(params).then((response) => {
				// 과정의 차시 정보만 병합(Merging only lesson data from the course)
				_.each(response.data.data, (course) => {
					this.lessonsList = this.lessonsList.concat(course.lessons)
				})

				// 다음 차시명 설정(set next lesson)
				let currentLessonIndex = _.findIndex(this.lessonsList,(lesson) => { return lesson.progressionId === this.currentProgressionId})
				let nextLessonIndex = this.lessonsList.length > 1 && this.lessonsList.length > currentLessonIndex ? currentLessonIndex += 1 : -1
				// if (nextLessonIndex) {
				//     this.nextLesson = this.lessonsList[nextLessonIndex]
				//     this.nextLessonName = this.lessonsList[nextLessonIndex].name
				// }

				if (nextLessonIndex) {
					this.nextLesson = this.lessonsList[nextLessonIndex]
					//this.nextLessonName = this.lessonsList[nextLessonIndex].name
					if(nextLessonIndex === -1){
						this.nextLessonName = this.$t('1999')
					} else {
						if (typeof(this.lessonsList[nextLessonIndex]) != "undefined"){
							this.nextLessonName = this.lessonsList[nextLessonIndex].name
						} else {
							this.nextLessonName = this.$t('1999')
						}

					}
				}


			}).catch((err) => {})
		},

		//나의 학습 상세로 이동(Go to my learning details)
		moveLearnView() {
			let goBackBookMarkLessson = localStorage.getItem('videoBookMarkLesson')
			let goBackLikeLessson = localStorage.getItem('videoLikeLesson')
			if(goBackBookMarkLessson == 'setVideoBookMarkLesson'){
				localStorage.removeItem('videoBookMarkLesson');
				this.$router.push({
					name: 'BookMarkedLesson'
				})
			}else if(goBackLikeLessson=='setVideoLikeLesson'){
				localStorage.removeItem('videoLikeLesson');
				this.$router.push({
					name: 'LikedLesson'
				})
			}else{
				this.$router.push({
				name: 'LearnView',
				params: {learnId: this.$route.params.learnId},
				query: this.$route.query
				})
			}
		},

		moveLearnViewClose() {
			this.pdfIfrem.contentWindow.document.getElementById("firstPage").click();

			let goBackBookMarkLessson = localStorage.getItem('videoBookMarkLesson')
			let goBackLikeLessson = localStorage.getItem('videoLikeLesson')
			if(goBackBookMarkLessson == 'setVideoBookMarkLesson'){
				localStorage.removeItem('videoBookMarkLesson');
				this.$router.push({
					name: 'BookMarkedLesson'
				})
			}else if(goBackLikeLessson=='setVideoLikeLesson'){
				localStorage.removeItem('videoLikeLesson');
				this.$router.push({
					name: 'LikedLesson'
				})
			}else if(typeof(this.$route.query.questionChatType) !='undefined'){
				this.$router.push({
				name: 'LearnView',
				params: {learnId: this.$route.params.learnId},
				query: {status:this.$route.query.status,tab:'ViewQuestion'}
				})
			}else{
				this.$router.push({
				name: 'LearnView',
				params: {learnId: this.$route.params.learnId},
				query: this.$route.query
				})
			}

			//alert('yes')
			// learnApi.learningStatus(this.$route.params.learnId).then((response) => {
			//     let learnStatus = response.data.data

			//     if(learnStatus.LearningStatus == 'COMPLETION' ){

			//         this.$confirm({
			//             title: this.$t("746"),
			//             content: this.$t("747"),
			//             accept: this.$t("749"),
			//             cancel: this.$t("748"),
			//         })
			//         .then(() => {
			//             learnApi.learnViewSurveys({learnId: this.$route.params.learnId}).then((response) => {
			//                 let surveyData = response.data.data[0]
			//                 if(surveyData){
			//                     this.takeSurvey(surveyData.id,surveyData.respondentId,surveyData.type.value)
			//                 }else{
			//                     let goBackBookMarkLessson = localStorage.getItem('videoBookMarkLesson')
			//                     let goBackLikeLessson = localStorage.getItem('videoLikeLesson')
			//                     if(goBackBookMarkLessson == 'setVideoBookMarkLesson'){
			//                         localStorage.removeItem('videoBookMarkLesson');
			//                         this.$router.push({
			//                             name: 'BookMarkedLesson'
			//                         })
			//                     }else if(goBackLikeLessson=='setVideoLikeLesson'){
			//                         localStorage.removeItem('videoLikeLesson');
			//                         this.$router.push({
			//                             name: 'LikedLesson'
			//                         })
			//                     }else{

			//                         this.$router.push({
			//                         name: 'LearnView',
			//                         params: {learnId: this.$route.params.learnId},
			//                         query: this.$route.query
			//                         })
			//                     }
			//                 }
			//             }).catch((err) => {

			//             })
			//         })
			//         .catch(() => {
			//             //this.$router.push("/login");
			//         });

			//     }else{
			//         let goBackBookMarkLessson = localStorage.getItem('videoBookMarkLesson')
			//         let goBackLikeLessson = localStorage.getItem('videoLikeLesson')
			//         if(goBackBookMarkLessson == 'setVideoBookMarkLesson'){
			//             localStorage.removeItem('videoBookMarkLesson');
			//             this.$router.push({
			//                 name: 'BookMarkedLesson'
			//             })
			//         }else if(goBackLikeLessson=='setVideoLikeLesson'){
			//             localStorage.removeItem('videoLikeLesson');
			//             this.$router.push({
			//                 name: 'LikedLesson'
			//             })
			//         }else{

			//             this.$router.push({
			//             name: 'LearnView',
			//             params: {learnId: this.$route.params.learnId},
			//             query: this.$route.query
			//             })
			//         }
			//     }

			// }).catch((err) => {

			// })


		},
		takeSurvey(id,respondentId,surveyDistributionType){
			 let params = {
				distId: id,
				respondentId: respondentId,
			}

			this.$router.push({
				name: 'IndependentSurveyIntro',
				params: params,
				query:{status:this.$route.query.status,learnId:this.$router.currentRoute.params.learnId,distributionType:surveyDistributionType}
			})
		},
		// moveLearnView() {
		//     this.$router.push({
		//         name: 'LearnView',
		//         params: {learnId: this.$route.params.learnId},
		//         query: this.$route.query
		//     })
		// },

		// 질문하기로 이동(Go to Ask a Question)
		moveQuestion() {
			this.$router.push({
				name: 'LessonViewQuestion',
				query: this.$route.query
			})
		},
		setRangeSlider(){
			//console.log('setRangeSlider')
			// First let's set the colors of our sliders
				// const settings = {
				//     fill: `var(--Secondarybtntext)`,
				//     background: 'rgba(255, 255, 255, 0.38)'
				// }

				// // First find all our sliders
				// const sliders = document.querySelectorAll('.range-slider');

				// // Iterate through that list of sliders
				// // ... this call goes through our array of sliders [slider1,slider2,slider3] and inserts them one-by-one into the code block below with the variable name (slider). We can then access each of wthem by calling slider
				// Array.prototype.forEach.call(sliders, (slider) => {


				//     slider.querySelector('input').addEventListener('input', (event) => {
				//         // 1. apply our value to the span

				//         applyFill(event.target);
				//     });
				//     // Don't wait for the listener, apply it now!
				//     applyFill(slider.querySelector('input'));
				// });

				// // This function applies the fill to our sliders by using a linear gradient background
				// function applyFill(slider) {
				//     // Let's turn our value into a percentage to figure out how far it is in between the min and max of our input
				//     const percentage = 100 * (slider.value - slider.min) / (slider.max - slider.min);
				//     // now we'll create a linear gradient that separates at the above point
				//     // Our background color will change here
				//     const bg = `linear-gradient(90deg, ${settings.fill} ${percentage}%, ${settings.background} ${percentage + 0.1}%)`;
				//     slider.style.background = bg;
				// }
		},
		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},
		donwloadFile(fileInfo) {
			let fileName = fileInfo.file.id ? fileInfo.file.originalName : fileInfo.split('/').pop()
			let resourceUri = fileInfo.file.id ? fileInfo.file.resourceUri : fileInfo

			httpService.fileDownload(resourceUri).then((response) => {
				const url = window.URL.createObjectURL(new Blob([response.data]))
				const link = document.createElement('a')

				link.href = url
				link.setAttribute('download', fileName)
				document.body.appendChild(link)
				link.click()
			}).catch(() => {
				console.log('error occured')
			})
		},

		getLearnPurposes(obj) {
      const languageInfo = JSON.parse(localStorageUtil.getLanguageInfo());
      const learnInfo = obj.find(info => info.lang.value === languageInfo.code);
      return learnInfo ? learnInfo.summary : "";
		},

		preventSaveAndPrint(event) {
			// 저장 단축키: Ctrl+S, Cmd+S
			if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 's') {
				event.preventDefault();
				console.log('브라우저 저장 동작 차단');
			}

			// 인쇄 단축키: Ctrl+P, Cmd+P
			if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'p') {
				event.preventDefault();
				console.log('브라우저 인쇄 동작 차단');
			}
		},
	}
}
</script>
<style scoped>
	 .range-slider__range.pdf-status {
			-webkit-appearance: none;
			width: 100%;
			height: 4px;
			border-radius: 0px;
		}

		.range-slider__range.pdf-status::-webkit-slider-thumb {
			width: 14px;
			height: 14px;
		}

		.range-slider__range.pdf-status.no-thumb::-webkit-slider-thumb {
			width: 14px;
			height: 14px;
		}

		.range-slider__range.pdf-status::-moz-range-thumb {
			width: 14px;
			height: 14px;
		}

		.range-slider__range.pdf-status.no-thumb::-moz-range-thumb {
			background: transparent;
		}

		input#pdf-page {
			height: 36px;
			width: 64px;
			text-align: center;
			background: transparent;
			color: var(--WhiteHigh);
			outline: none;
			border: 1px solid var(--WhiteBorder);
			border-radius: 4px;
			-webkit-appearance: none;
			-moz-appearance: textfield;
		}

		input#pdf-page::-webkit-outer-spin-button,
		input#pdf-page::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}
		.home-progressbar {
			position: absolute;
			height: 4px;
			background: var(--Saleline);
		}
		.disAbledPlusAndMinus{
			opacity: 0.5;
			cursor: none;
		}
		.waterMarkInner {
			top:50%;
			z-index: 88;
			left: 50%;
			display: inline-block;
			position: absolute;
			transform: translate(-50%,-50%);
		}
		.waterMarkInner span {
			font-size: 4vw;
			line-height: 1;
			opacity: 0.3;
			transform: rotate(-23deg);
			font-weight: 800;
			user-select: none;
			padding-bottom: 5px;
			display: inline-block;
		}
		.footer-center-absolute{
			position:absolute;
			left: 50%;
			transform: translateX(-50%);
		}
		html[dir="rtl"] .footer-center-absolute{
			right: 50%;
		}

</style>
